import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../../components/layout/Sidebar';
import './DashboardPage.scss';

const DashboardPage = () => (
  <div className="DashboardPage">
    <Sidebar />
    <Outlet />
  </div>
);

export default DashboardPage;
